import { useState } from 'react';
import { Arrow, Refresh, Shield, Sparkle } from '../components/icons';
import { Wordmark } from '../components/Wordmark';
import { LEGAL, haptic, openLegal } from '../telegram';

/** Первый вход — docs/design/Onboarding.dc.html. */
export function Onboarding({ onAccept }: { onAccept: () => Promise<void> }) {
  const [checked, setChecked] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    if (!checked || busy) return;
    haptic();
    setBusy(true);
    setError(null);
    try {
      await onAccept();
    } catch {
      setError('Не получилось. Проверь интернет и попробуй ещё раз.');
      setBusy(false);
    }
  };

  return (
    <main className="screen screen--hero onb">
      <header className="onb__header">
        <Wordmark size={26} />
      </header>

      <div className="onb__stack" aria-hidden="true">
        <div className="onb__card onb__card--left">
          <span className="glass-chip" style={{ left: 10, bottom: 10 }}>
            1920-е
          </span>
        </div>
        <div className="onb__card onb__card--right">
          <span className="glass-chip" style={{ right: 10, bottom: 10 }}>
            Аниме
          </span>
        </div>
        <div className="onb__card onb__card--center">
          <span className="glass-chip onb__top-chip">#1 сегодня</span>
          <span className="glass-chip" style={{ left: 12, bottom: 12, height: 28, padding: '0 12px', fontSize: 12.5 }}>
            Рыцарь
          </span>
        </div>
      </div>

      <div style={{ padding: '0 24px', textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 10 }}>
        <h1 className="onb__title">
          Стань героем
          <br />
          любого тренда
        </h1>
        <p className="onb__lead">
          Первая генерация — <b>бесплатно</b>. Без подписок и токенов.
        </p>
      </div>

      <ul className="onb__perks">
        <li>
          <Arrow />
          Цена в рублях видна до генерации
        </li>
        <li>
          <Refresh />
          Брак переделаем бесплатно
        </li>
        <li>
          <Shield />
          Ошибка модели — деньги вернутся сами
        </li>
      </ul>

      <div className="onb__footer">
        <label className="onb__consent">
          <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
          <span>
            Мне есть 18. Согласен с <LegalLink page="terms">правилами</LegalLink> и <LegalLink page="privacy">обработкой фото</LegalLink> — они нужны только для генерации.
          </span>
        </label>
        {error && (
          <p className="error-text" role="alert">
            {error}
          </p>
        )}
        <button type="button" className="btn-accent" disabled={!checked || busy} onClick={submit}>
          <Sparkle />
          Попробовать бесплатно
        </button>
      </div>
    </main>
  );
}

/** Ссылка внутри подписи галочки: открывает документ и не переключает галочку. */
function LegalLink({ page, children }: { page: 'terms' | 'privacy'; children: string }) {
  return (
    <a
      href={LEGAL[page]}
      className="onb__legal"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        openLegal(page);
      }}
    >
      {children}
    </a>
  );
}
